import { ImplementorTemplateParams } from "components/stories/video-studio/utils/creatomate/setCustomTemplate";
import deleteElement from "components/stories/video-studio/utils/creatomate/deleteElement";
import syncMediaElements from "components/stories/video-studio/utils/creatomate/syncMediaElements";
import { ELEMENT_NAMES } from "components/stories/video-studio/utils/constants";
import { cacheAssetIfNeeded, calculateVideoDuration } from "../../utils/utils";
import findElementByName from "../../utils/findElementByName";

const merckVerticalWithPrompt = async ({
  preview,
  mediaElements,
  defaultVideoProperties,
  story
}: ImplementorTemplateParams) => {
  cacheAssetIfNeeded(preview, story);

  const json = preview.getSource();
  const elements = json?.elements;

  const promptElement = findElementByName(elements, ELEMENT_NAMES.PROMPT);
  const titleElement = findElementByName(elements, ELEMENT_NAMES.TITLE);
  const nameElement = findElementByName(elements, ELEMENT_NAMES.NAME);
  const storyVideoElement = findElementByName(elements, ELEMENT_NAMES.STORY);
  const tealOverlayElement = findElementByName(elements, ELEMENT_NAMES.TEAL_OVERLAY);

  await syncMediaElements(preview, mediaElements, {
    ...defaultVideoProperties,
    track: storyVideoElement?.track,
    x: storyVideoElement?.x,
    width: storyVideoElement?.width,
    height: storyVideoElement?.height,
    border_radius: storyVideoElement?.border_radius
  }, 0);
  await deleteElement(preview, storyVideoElement?.id);
  const videoDuration = calculateVideoDuration(mediaElements);

  const modifications = {
    [`${promptElement?.id}.text`]: story?.question?.question,
    [`${titleElement?.id}.text`]: story?.creator?.title || "",
    [`${nameElement?.id}.text`]: story?.creator?.name,
    [`${storyVideoElement?.id}.duration`]: story?.media?.duration || "media",
    duration: videoDuration
  };

  if (videoDuration < 10) {
    modifications[`${nameElement?.id}.duration`] = videoDuration;
    modifications[`${titleElement?.id}.duration`] = videoDuration;
    modifications[`${promptElement?.id}.duration`] = videoDuration;
    modifications[`${tealOverlayElement?.id}.duration`] = videoDuration;
  }
  await preview.applyModifications(modifications);
};

export default merckVerticalWithPrompt;
